import { render, staticRenderFns } from "./AssistantCatHomeAssistTabs.vue?vue&type=template&id=c2419a60&scoped=true"
import script from "./AssistantCatHomeAssistTabs.vue?vue&type=script&lang=ts"
export * from "./AssistantCatHomeAssistTabs.vue?vue&type=script&lang=ts"
import style0 from "./AssistantCatHomeAssistTabs.vue?vue&type=style&index=0&id=c2419a60&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2419a60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2419a60')) {
      api.createRecord('c2419a60', component.options)
    } else {
      api.reload('c2419a60', component.options)
    }
    module.hot.accept("./AssistantCatHomeAssistTabs.vue?vue&type=template&id=c2419a60&scoped=true", function () {
      api.rerender('c2419a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/AssistantCatHomeAssistTabs.vue"
export default component.exports